var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8"},[_c('div',[_c('CreateNoteAction',{attrs:{"contact-id":_vm.contactId},on:{"create":_vm.refreshList}})],1),_c('div',{staticClass:"py-5"},[_c('NoteList',{ref:"noteList",attrs:{"contact-id":_vm.contactId},on:{"destroy":_vm.refreshList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }